module.exports = __webpack_public_path__ + "img/3_james_n.4f892c55.png";